export const DRAG_DROP_RELEASED_OUTSIDE_EVENT = 'released-outside';

export const DRAG_TRIGGER_REGISTERED_EVENT = 'trigger-registered';

export const DRAG_DROP_RELEASED = 'released';

export const DRAGGING_OUTSIDE_DROPZONE = 'dragging-outside-dropzone';

export const DRAGGING_INSIDE_DROPZONE = 'dragging-inside-dropzone';

export const DRAGGABLE_RELEASED = 'draggable-released';

export const DRAGGABLE_SELECTED = 'draggable-selected';

export const DROPZONE_SELECTED = 'dropzone-selected';

export const EXTERNAL_DROPZONE_SELECTED = 'external-dropzone-selected';
